import { render, staticRenderFns } from "./InboxTicket.vue?vue&type=template&id=454085ce&scoped=true&"
import script from "./InboxTicket.vue?vue&type=script&lang=ts&"
export * from "./InboxTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454085ce",
  null
  
)

export default component.exports